/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, September 2020
 */

import React from 'react';
import ChoiceRadioButton from '../components/choice-radio-button';

type RadioButtonProps = {
  name: string;
  value?: string;
  colorStyle?: string;
  onFocus?: () => void;
  children?: React.ReactNode;
} & React.InputHTMLAttributes<HTMLInputElement>;
const RadioButton = React.forwardRef(
  (
    { children, name, value, colorStyle, onFocus, ...rest }: RadioButtonProps,
    ref: React.Ref<HTMLInputElement>,
  ) => (
    <ChoiceRadioButton
      innerRef={ref}
      name={name}
      score={value}
      colorStyle={colorStyle}
      onFocus={onFocus}
      {...rest}
    >
      {children}
    </ChoiceRadioButton>
  ),
);

export default RadioButton;
